<template>
	<div class="app-container">
		<div class="alert alert-warning">You are not authorized to view this page.</div>
	</div>
</template>

<script>
export default {
	name: "Unauthorized",
};
</script>

<style>
</style>